'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import moment from 'moment';

var StepButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(StepButton, _Component);

  function StepButton(props) {
    (0, _classCallCheck3.default)(this, StepButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call(this, props));

    _this.state = {
      showModal: false,
      primary: _this.props.data.primary || '',
      item: _this.props.data.item || null,
      price: _this.props.data.item.price || '',
      originalPrice: _this.props.data.item.originalPrice || '',
      duration: _this.props.data.item.duration || '',
      index: _this.props.index || '',
      border: _this.props.border || false
    };

    _this.showDescModal = _this.showDescModal.bind(_this);
    _this.hideDescModal = _this.hideDescModal.bind(_this);
    return _this;
  }
  // @css


  (0, _createClass3.default)(StepButton, [{
    key: 'input',
    value: function input() {
      var styles = require('./StepButton.scss');
      var index = this.state.index;
      var borderTopRadius = styles.borderTopRadius,
          borderBottomRadius = styles.borderBottomRadius;
      var input = styles.input;

      switch (index) {
        case 'one':
          input = input + ' ' + borderTopRadius + ' ' + borderBottomRadius;
          break;
        case 'first':
          input = input + ' ' + borderTopRadius;
          break;
        case 'last':
          input = input + ' ' + borderBottomRadius;
          break;
        default:
          break;
      }
      return input;
    }
  }, {
    key: 'box',
    value: function box() {
      var styles = require('./StepButton.scss');
      var _state = this.state,
          border = _state.border,
          index = _state.index;
      var borderBottom = styles.borderBottom;
      var box = styles.box;

      if (border && index !== 'one') box = box + ' ' + borderBottom;
      return box;
    }
    // primary() {
    //   const styles = require('./StepButton.scss');
    //   const { extra } = this.state;
    //   let { primary } = styles;
    //   const { marginBottom } = styles;
    //   if (extra) primary = `${primary} ${marginBottom}`;
    //   return primary;
    // }

  }, {
    key: 'showDescModal',
    value: function showDescModal() {
      this.setState({ showModal: true });
    }
  }, {
    key: 'hideDescModal',
    value: function hideDescModal() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./StepButton.scss');
      var showModal = this.state.showModal;

      if (!(this.props.data && this.props.data.item)) {
        return null;
      }
      var _props$data = this.props.data,
          primary = _props$data.primary,
          item = _props$data.item;
      var price = item.price,
          originalPrice = item.originalPrice,
          duration = item.duration,
          description = item.description;
      var _props = this.props,
          bookingEnabled = _props.bookingEnabled,
          _onClick = _props.onClick;

      var input = this.input();
      var box = this.box();
      // const sPrimary = this.primary();
      return _react2.default.createElement(
        'div',
        { className: input },
        _react2.default.createElement(
          'div',
          { className: box },
          _react2.default.createElement(
            'div',
            {
              className: styles.info,
              onClick: description && this.showDescModal
            },
            _react2.default.createElement(
              'div',
              { className: styles.primary },
              description && _react2.default.createElement('img', { src: '/booking/details.png' }),
              primary
            ),
            !!price && _react2.default.createElement(
              'div',
              { className: styles.priceContainer },
              _react2.default.createElement(
                'span',
                {
                  className: styles.price,
                  style: { color: !!originalPrice ? '#FC8B35' : '#A8A8A8' }
                },
                _support.Helper.formatMoney(price)
              ),
              !!originalPrice && _react2.default.createElement(
                'span',
                { className: styles.originalPrice },
                _support.Helper.formatMoney(originalPrice)
              )
            ),
            _react2.default.createElement(
              _components.ModalCustom,
              {
                title: { text: primary },
                closeButton: true,
                show: showModal,
                onHide: this.hideDescModal
              },
              _react2.default.createElement('div', {
                className: styles.modalDesc,
                dangerouslySetInnerHTML: { __html: description }
              })
            )
          ),
          bookingEnabled ? _react2.default.createElement(
            'div',
            { className: styles.actionGroup },
            !!duration && _react2.default.createElement(
              'div',
              { className: styles.duration },
              _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
              _react2.default.createElement(
                'span',
                null,
                duration,
                ' ph\xFAt'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.action, onClick: function onClick() {
                  return _onClick(item);
                } },
              _react2.default.createElement(
                'div',
                { className: styles.btn },
                '\u0110\u1EB7t Ngay'
              )
            )
          ) : _react2.default.createElement(
            'div',
            { className: styles.durationView },
            !!duration && _react2.default.createElement(
              'div',
              { className: styles.duration },
              _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
              _react2.default.createElement(
                'span',
                null,
                duration,
                ' ph\xFAt'
              )
            )
          )
        )
      );
    }
  }]);
  return StepButton;
}(_react.Component), _class.propTypes = {
  bookingEnabled: _react.PropTypes.bool,
  data: _react.PropTypes.object,
  index: _react.PropTypes.string,
  border: _react.PropTypes.bool,
  // @action
  onClick: _react.PropTypes.func
}, _temp);
exports.default = StepButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/StepButton.js
// module id = 1571
// module chunks = 0